import articleTypes from "astrid-firestore/src/api/articles/constants/articleTypes";

import contributorRoles from "../../src/api/articles/constants/contributorRoles";
import getDocumentData from "../../src/utils/getDocumentData";

import createArticleDelivery from "./createArticleDelivery";
import createChannels from "./createChannels";
import createCover from "./createCover";
import createDocumentIdAndRef from "./createDocumentIdAndRef";
import createEbookArtifact from "./createEbookArtifact";

export default async function createEbook({ api, env }, { production, publisher, commonArticleData }) {
	const { id, ref } = createDocumentIdAndRef({ api, env }, { collection: "articles" });
	const article = {
		id,
		ref,
		type: articleTypes.EBOOK,
		name: production.title,
		isbn: production.deliveryEbook.isbn,
		synopsis: production.deliveryEbook?.synopsis || production.synopsis || "",
		bokgruppe: production.deliveryEbook?.bokgruppe?.toString() || null,
		...commonArticleData,
	};
	const cover = await createCover({ api, env }, { img: production.deliveryEbook.img });
	const coverThumb = await createCover({ api, env }, { img: production.deliveryEbook.imgThumb });
	const fullPublisherDocRef = api.convertFromLiveToStage
		? api.stage.db.collection("organizations").doc(publisher.id)
		: api[env].db.collection("organizations").doc(publisher.id);
	const fullPublisherDoc = await getDocumentData(fullPublisherDocRef);
	const artifact =
		production.deliveryEbook?.path && (await createEbookArtifact({ api, env }, { production, article }));
	const { channels, channelIds } = await createChannels(
		{ api, env },
		{ article, fullPublisherDoc, production, articleType: "ebook" },
	);
	const delivery = createArticleDelivery({ channels, channelIds });
	const contributors = article?.contributors?.filter((contributor) => contributor.role !== contributorRoles.NARRATOR);
	return {
		...article,
		artifact,
		contributors,
		cover,
		coverThumb,
		channels,
		channelIds,
		delivery,
	};
}
